<!--
 * @Author: your name
 * @Date: 2020-12-09 19:52:34
 * @LastEditTime: 2020-12-19 16:59:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/components/popover/popoverContent.vue
-->
<template>
  <ul class="my-list">
    <li v-for="(item, index) in lists" :key="index" @click="onJumpto(item)">
      <span class="avatar">
        <el-badge :value="item.unreadAmount" :max="99"
          >
          <!-- <el-avatar :src="image.groupAvatar" /> -->
          <img :src="image.groupAvatar" alt="avatar">
        </el-badge>
      </span>
      <span class="title">{{ item.groupTitle }}</span>
      <!-- <div class="right-top">00:00</div> -->
    </li>
  </ul>
</template>
<script>
import groupAvatar from "@/assets/img/group-avatar.png";
export default {
  name: "popoverContent",
  props: {
    lists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      image: {
        groupAvatar: groupAvatar,
      },
    };
  },
  methods: {
    onJumpto(item) {
      this.$emit("onJumpto", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.my-list {
  min-width: 260px;
  max-width: 320px;
  max-height: 300px;
  overflow-y: auto;
  padding-left: 12px;
  li {
    list-style: none;
    padding: 12px 0 8px 0;
    .avatar {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      margin-right: 14px;
      img {
        width: 100%;
      }
    }
    .title {
      font-size: 12px;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/popover/popoverContent.vue